// ShipLabel.tsx — The callout for a freighter in the system view. Unlike EntityLabel (which
// centres a name ABOVE a body), a ship's label sits to the RIGHT of its selection bracket and
// is left-aligned, like a HUD readout — so the name, cargo/crew, and origin→destination route
// don't overlap the reticle. Anchored at the ship; CSS offsets it clear of the 66px bracket.
import { Html } from '@react-three/drei';

interface Props {
  name: string;
  /** Cargo · crew summary (shown when lit). */
  meta?: string;
  /** Origin → destination route line (shown when lit). */
  route?: string;
  lit?: boolean;
}

export function ShipLabel({ name, meta, route, lit = false }: Props) {
  return (
    <Html zIndexRange={[19, 0]} style={{ pointerEvents: 'none' }}>
      <div className={lit ? 'ship-label lit' : 'ship-label'}>
        <span className="name">{name}</span>
        {meta ? <span className="meta">{meta}</span> : null}
        {route ? <span className="route">{route}</span> : null}
      </div>
    </Html>
  );
}
